/**
 * Strategy pattern for ID detection (Single Responsibility)
 */
export class IdDetector {
  constructor() {
    this.patterns = [
      // Existing patterns
      { type: 'HKID', pattern: /^[A-Z]{1,2}\d{6}[A-Z0-9]$/i },
      { type: 'TWID', pattern: /^[A-Z][12]\d{8}$/i },
      { type: 'AADHAAR', pattern: /^\d{4}\s?\d{4}\s?\d{4}$/ },
      { type: 'NRIC', pattern: /^[ST]\d{7}[A-Z]$/i },
      { type: 'FIN', pattern: /^[FG]\d{7}[A-Z]$/i },
      { type: 'PAN', pattern: /^[A-Z]{5}\d{4}[A-Z]$/i },
      { type: 'SSN', pattern: /^\d{3}-?\d{2}-?\d{4}$/ },
      { type: 'SIN', pattern: /^\d{3}[\s-]?\d{3}[\s-]?\d{3}$/ },
      { type: 'NINO', pattern: /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z]\d{6}[A-D]$/i },
      { type: 'BSN', pattern: /^\d{9}$/ },
      { type: 'CPF', pattern: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/ },
      { type: 'RUT', pattern: /^\d{1,2}\.\d{3}\.\d{3}-[\dK]$/i },
      { type: 'CUIL', pattern: /^\d{2}-?\d{8}-?\d$/ },
      { type: 'RFC', pattern: /^[A-Z&Ñ]{3,4}\d{6}[A-Z\d]{3}$/i },
      { type: 'PERSONNUMMER', pattern: /^\d{6}-?\d{4}$/ },
      { type: 'PERSONALNUMMER', pattern: /^\d{10}$/ },
      { type: 'CPR', pattern: /^\d{6}-?\d{4}$/ },
      { type: 'PESEL', pattern: /^\d{11}$/ },
      { type: 'CNP', pattern: /^\d{13}$/ },
      
      // New comprehensive patterns
      { type: 'AUS', pattern: /^\d{8,9}$/ },                    // Australia TFN
      { type: 'NZ', pattern: /^\d{8,9}$/ },                     // New Zealand IRD
      { type: 'JP', pattern: /^\d{12}$/ },                      // Japan My Number
      { type: 'KR', pattern: /^\d{6}-?\d{7}$/ },                // South Korea RRN
      { type: 'CN', pattern: /^\d{17}[\dX]$/i },                // China ID
      { type: 'TH', pattern: /^\d{13}$/ },                      // Thailand ID
      { type: 'MY', pattern: /^\d{6}-?\d{2}-?\d{4}$/ },         // Malaysia NRIC
      { type: 'PH', pattern: /^\d{4}-?\d{7}-?\d$/ },            // Philippines UMID
      { type: 'VN', pattern: /^\d{12}$/ },                      // Vietnam ID
      { type: 'ID', pattern: /^\d{16}$/ },                      // Indonesia NIK
      { type: 'ZA', pattern: /^\d{13}$/ },                      // South Africa ID
      { type: 'EG', pattern: /^\d{14}$/ },                      // Egypt ID
      { type: 'NG', pattern: /^\d{11}$/ },                      // Nigeria NIN
      { type: 'KE', pattern: /^\d{7,8}$/ },                     // Kenya ID
      { type: 'GH', pattern: /^GHA-\d{9}-\d$/i },               // Ghana Card
      { type: 'FR', pattern: /^\d{13}$/ },                      // France INSEE
      { type: 'DE', pattern: /^\d{11}$/ },                      // Germany Tax ID
      { type: 'IT', pattern: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i }, // Italy Fiscal Code
      { type: 'ES', pattern: /^\d{8}[A-Z]$/i },                 // Spain DNI
      { type: 'PT', pattern: /^\d{8}\s?\d{1}\s?[A-Z]{2}\d{1}$/i }, // Portugal Citizen Card
      { type: 'RU', pattern: /^\d{4}\s?\d{6}$/ },               // Russia Passport
      { type: 'UA', pattern: /^\d{10}$/ },                      // Ukraine Tax Number
      { type: 'TR', pattern: /^\d{11}$/ },                      // Turkey TC Kimlik
      { type: 'IL', pattern: /^\d{9}$/ },                       // Israel ID
      { type: 'AR', pattern: /^784-\d{4}-\d{7}-\d$/ },          // UAE Emirates ID
      { type: 'SA', pattern: /^[12]\d{9}$/ },                   // Saudi Arabia ID
      { type: 'PK', pattern: /^\d{5}-?\d{7}-?\d$/ },            // Pakistan CNIC
      { type: 'BD', pattern: /^\d{10}|\d{13}|\d{17}$/ },        // Bangladesh NID
      { type: 'LK', pattern: /^\d{9}[VX]|\d{12}$/i },           // Sri Lanka NID
      { type: 'MM', pattern: /^\d{1,2}\/[A-Z]{6}\([A-Z]\)\d{6}$/i } // Myanmar NRC
    ];
  }

  detect(id) {
    if (!id || typeof id !== 'string') {
      return null;
    }

    const cleanId = id.trim();
    
    for (const { type, pattern } of this.patterns) {
      if (pattern.test(cleanId)) {
        return type;
      }
    }

    return null;
  }

  addPattern(type, pattern) {
    this.patterns.push({ type: type.toUpperCase(), pattern });
  }
}